import success from '../../assets/images/success.webp?no-inline';
import warning from '../../assets/icons/warning.svg?no-inline';

export enum StatusModalStates {
  SUCCESS = 'SUCCESS',
  LOADING = 'LOADING',
  IDLE = 'IDLE',
  ERROR = 'ERROR',
}

export const AltText = {
  [StatusModalStates.SUCCESS]: 'Success',
  [StatusModalStates.LOADING]: '',
  [StatusModalStates.IDLE]: '',
  [StatusModalStates.ERROR]: 'Error',
};
export const Icon = {
  [StatusModalStates.SUCCESS]: success,
  [StatusModalStates.LOADING]: '',
  [StatusModalStates.IDLE]: '',
  [StatusModalStates.ERROR]: warning,
};
